import React, { useContext, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  makeStyles,
  Drawer as MaterialDrawer,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  useMediaQuery,
  useTheme,
  Dialog,
  Button,
  IconButton,
} from "@material-ui/core";
import { AuthContext, PathContext } from "../context";
import {
  ProfileVariantIcon,
  AlertIcon,
  DocIcon,
  ShareIcon,
  CloseSesionIcon,
  CircleArrowFowardIcon,
  MedicalKitIcon,
  RequestIcon,
  ClockIcon,
  ProfileIcon,
  SupportIcon,
  ArrowDownIcon,
} from "../icons";
import { Loader, PopUp } from "./";
import { modals } from "../constants";
import { useEffect } from "react";
import LinkIcon from "@material-ui/icons/Link";
import DoneIcon from "@material-ui/icons/Done";
import CloseIcon from "@material-ui/icons/Close";

export default function Drawer(props) {
  const { open, setOpen } = props;
  const classes = useStyles({ props })();
  const history = useHistory();
  const { authState } = useContext(AuthContext);
  const [modal, setModal] = useState(false);
  const { setTab } = useContext(PathContext);
  const matches = useMediaQuery(useTheme().breakpoints.up("md"));
  const location = useLocation();
  const [modalName, setModalName] = useState(modals[6]);

  const [openShareModal, setOpenShareModal] = useState(false);
  const toggleShareModal = () => {
    setOpenShareModal(!openShareModal);
  };

  const [installApp, setInstallApp] = useState(null);
  // let installApp;
  useEffect(() => {
    const handle = function (e) {
      console.log({ beforeinstallprompt: e });
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash installAppthe event so it can be triggered later.
      setInstallApp(e);
    };
    window.addEventListener("beforeinstallprompt", handle);
    return () => window.removeEventListener('beforeinstallprompt', handle)
  }, []);

  useEffect(() => {
    console.log({ installApp });
  }, [installApp]);

  const [loading, setLoading] = useState(false);
  const shareApp = async () => {
    let shareData = {
      title: "UNIO",
      text: "Unio App",
      url: "https://unio-front.vercel.app",
    };

    try {
      setLoading(true);
      await new Promise((resolve)=> setTimeout(resolve, 3000));
      await window.navigator.share(shareData);
      console.log("Exito");
      setLoading(false);
    } catch (error) {
      toggleShareModal();
      console.log("Error", error);
    }
  };

  const PWAInstallIcon = {
    name: "Instalar",
    Icon: () => <ArrowDownIcon />,
    onClick: () => {
      console.log({ installApp });
      installApp?.prompt();
    },
  };

  const options = [
    {
      name: "Sobre Unio",
      Icon: () => <AlertIcon color={"#2196C0"} />,
      onClick: () => {
        history.push("/about-us");
        setOpen(!open);
      },
    },
    {
      name: "Tutorial",
      Icon: () => <DocIcon color={"#2196C0"} />,
      onClick: () => {
        setModalName(modals[9]);
        setModal(!modal);
      },
    },
    {
      name: "Soporte",
      Icon: () => <SupportIcon color={"#2196C0"} />,
      onClick: () => {
        history.push("/support");
        setOpen(!open);
      },
    },
    { name: "Compartir", Icon: () => <ShareIcon />, onClick: shareApp },
    {
      name: "Cerrar sesión",
      Icon: () => <CloseSesionIcon />,
      onClick: () => {
        setModalName(modals[6]);
        setModal(!modal);
      },
    },
  ];

  const optionsDesktop = (value) => {

    const opts = [
      {
        name: "Botiquín",
        Icon: () => (
          <MedicalKitIcon color={value !== "/" ? "#2196C0" : "#192A7F"} />
        ),
        onClick: () => {
          history.push("/");
        },
      },
      // {
      //   name: "Solicitar",
      //   Icon: () => (
      //     <RequestIcon color={value !== "/request" ? "#2196C0" : "#192A7F"} />
      //   ),
      //   onClick: () => {
      //     value !== "/request" && history.push("/request");
      //   },
      // },
      {
        name: "Historial",
        Icon: () => (
          <ClockIcon color={value !== "/history" ? "#2196C0" : "#192A7F"} />
        ),
        onClick: () => {
          history.push("/history");
        },
      },
      {
        name: "Perfil",
        Icon: () => (
          <ProfileIcon color={value !== "/profile" ? "#2196C0" : "#192A7F"} />
        ),
        onClick: () => {
          history.push("/profile");
        },
      },
      {
        name: "Sobre Unio",
        Icon: () => (
          <AlertIcon color={value !== "/about-us" ? "#2196C0" : "#192A7F"} />
        ),
        onClick: () => {
          history.push("/about-us");
          setTab({ index: 4 });
        },
      },
      {
        name: "Tutorial",
        Icon: () => <DocIcon color={"#2196C0"} />,
        onClick: () => {
          setModalName(modals[9]);
          setModal(!modal);
        },
      },
      {
        name: "Soporte",
        Icon: () => (
          <SupportIcon color={value !== "/support" ? "#2196C0" : "#192A7F"} />
        ),
        onClick: () => {
          history.push("/support");
          setTab({ index: 5 });
        },
      },
      {
        name: "Compartir",
        Icon: () => <ShareIcon color={value !== "/" ? "#2196C0" : "#192A7F"} />,
        onClick: shareApp,
      },
  
      {
        name: "Cerrar sesión",
        Icon: () => (
          <CloseSesionIcon color={value !== "/" ? "#2196C0" : "#192A7F"} />
        ),
        onClick: () => {
          setModalName(modals[6]);
          setModal(!modal);
          setTab({ index: null });
        },
      },
    ]

    installApp?.isTrusted && opts?.push(PWAInstallIcon) 
    
    return opts

  };

  if (installApp?.isTrusted) {
    options.push(PWAInstallIcon)
  }

  const [copied, setCopied] = useState(false);
  const copyLink = () => {
    navigator.clipboard
      .writeText(window.location.toString())
      .then(() => setCopied(true))
      .catch(() => alert("No se pudo copiar el link."));
    setTimeout(() => setCopied(false), 3000);
  };

  return (
    <MaterialDrawer
      BackdropProps={{ invisible: false }}
      open={open}
      onClose={() => setOpen(!open)}
      anchor={"left"}
      variant={matches ? "permanent" : "temporary"}
      elevation={2}
      className={classes.drawer}
      classes={{ paper: classes.drawerPaper }}
    >
      {loading && <Loader loading={true} />}
      <Dialog open={openShareModal} onClose={toggleShareModal} maxWidth="40rem" >
        <Grid container style={{ height: '2rem',justifyContent: 'flex-end',position: 'relative' }}>
          <IconButton onClick={toggleShareModal} style={{ position: 'absolute', padding: '1rem' }}>
            <CloseIcon />
          </IconButton>
        </Grid>
        <Grid
          direction="column"
          container
          style={{  padding: "1rem", alignItems: "center" }}
        >
          <Grid item>
            <Typography
              variant="h5"
              color="primary"
              style={{ fontWeight: "bold", marginBottom: "1rem" }}
            >
              Funcionalidad No Disponible en el Dispositivo
            </Typography>
          </Grid>
          <Grid item style={{ padding: "2rem" }}>
            <Typography style={{ fontWeight: "bold" }}>
              Puede Copiar el Link para Compartir:
            </Typography>

            <Button
              variant="outlined"
              onClick={copyLink}
              endIcon={copied ? <DoneIcon /> : <LinkIcon />}
            >
              {window.location.toString()}
            </Button>
          </Grid>
        </Grid>
      </Dialog>
      <Grid
        container
        className={classes.imageContainer}
        justify="center"
        alignItems="flex-start"
      >
        <img src="../../assets/logo/logo-unio.svg" alt="Unio" />
      </Grid>
      <Grid container className={classes.drawerCard}>
        <Grid item sm={12} xs={12}>
          <Grid container>
            <Grid item xs={2}>
              <ProfileVariantIcon />
            </Grid>
            <Grid item xs={10}>
              {authState.user?.doctor.gender === 'FEMENINO' ? (
              <>
                <Typography>{`Dra. ${authState.user?.doctor.name} ${authState.user?.doctor.lastName}`}</Typography>
                <Typography>{`${authState.user?.doctor.specialties[0].name}`}</Typography>
              </>
            ) : (
              <>
                <Typography>{`Dr. ${authState.user?.doctor.name} ${authState.user?.doctor.lastName}`}</Typography>
                <Typography>{`${authState.user?.doctor.specialties[0].name}`}</Typography>
            </>
          )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} style={{}}>
          <List className={classes.drawerButtonList}>
            {!matches &&
              options.map((option, index) => (
                <ListItem
                  key={index}
                  button
                  className={classes.buttonDrawer}
                  onClick={option.onClick}
                >
                  <ListItemIcon
                    style={{ width: "fit-content", minWidth: "fit-content" }}
                  >
                    <option.Icon />
                  </ListItemIcon>
                  <ListItemText
                    className={classes.drawerListText}
                    style={{ color: "#192A7F", padding: "0 0 0 15px" }}
                    primary={option.name}
                  />
                  <ListItemIcon style={{ justifyContent: "flex-end" }}>
                    <CircleArrowFowardIcon />
                  </ListItemIcon>
                </ListItem>
              ))}
            {matches &&
              optionsDesktop(location.pathname).map((option, index) => (
                <ListItem
                  key={index}
                  button
                  className={classes.buttonDrawer}
                  onClick={option.onClick}
                >
                  <ListItemIcon
                    style={{ width: "fit-content", minWidth: "fit-content" }}
                  >
                    <option.Icon />
                  </ListItemIcon>
                  <ListItemText
                    className={classes.drawerListText}
                    style={{ color: "#192A7F", padding: "0 0 0 15px" }}
                    primary={option.name}
                  />
                  <ListItemIcon style={{ justifyContent: "flex-end" }}>
                    <CircleArrowFowardIcon />
                  </ListItemIcon>
                </ListItem>
              ))}
          </List>
        </Grid>
      </Grid>
      <PopUp
        modalName={modalName}
        open={modal}
        setModal={() => setModal(!modal)}
      />
    </MaterialDrawer>
  );
}

const drawerWidth = 276;

const useStyles = ({ props }) =>
  makeStyles((theme) => ({
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      height: "100vh",
      '@supports (height: 100dvh)': {
        height: '100dvh',
      },
      zIndex: "1100!important",
      "@media (min-width: 1024px) and (min-height: 1366px)": {
        width: "30%!important",
      },
      [theme.breakpoints.up("md")]: {
        width: "20%",
      },
    },
    imageContainer: {
      padding: 20,
      "& img": {
        height: "auto",
        "@media(min-width:320px)": {
          width: 60,
        },
        "@media(min-width:360px)": {
          width: 80,
        },
        [theme.breakpoints.up("md")]: {
          width: "30%",
        },
      },
    },
    drawerPaper: {
      width: "100%",
      borderRadius: "0 12px 12px 0",
      position: "relative",
      "&::-webkit-scrollbar": {
        width: "1px",
        height: "8px",
      },
      "&::-webkit-scrollbar-track": {
        boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
        webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "rgba(0,0,0,.1)",
        borderRadius: "10px",
      },
      [theme.breakpoints.up("md")]: {
        border: 0,
        borderRadius: 0,
        boxShadow: "0px 5px 10px rgba(198, 198, 198, 0.5)",
      },
    },
    buttonDrawer: {
      padding: "0 8px 0 0",
      margin: "0 0 8px 0",
    },
    drawerButtonList: {
      width: "100%",
      height: "calc(100vh - 277px)",
      '@supports (height: 100dvh)': {
        height: 'calc(100dvh - 277px)',
      },
      "max-height": "300px",
      "overflow-y": "auto",
      display: "flex",
      "flex-direction": "column",
      "justify-content": "space-between",
      [theme.breakpoints.up("md")]: {
        "max-height": "500px",
      },
    },
    buttonDrawerActive: {
      backgroundColor: theme.palette.primary.main,
      color: "#FFF",
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
      },
    },
    drawerListText: {
      fontSize: "1.313rem",
      fontWeight: "500",
      lineHeight: "1.5rem",
      letterSpacing: "0.05em",
    },
    drawerCard: {
      borderRadius: 45,
      boxShadow: "0px -5px 7px rgba(198, 198, 198, 0.25)",
      background: "#FFFFFF",
      width: "100%",
      display: "block",
      padding: "25px 0px 0px 30px",
      [theme.breakpoints.up("md")]: {
        boxShadow: "unset",
      },
      "& > div": {
        "& > div": {
          "& div:nth-child(2)": {
            padding: "0 0 0 10px",
            "& p:nth-child(1)": {
              fontSize: "1.125rem",
              color: theme.palette.primary.main,
              lineHeight: "1.375rem",
              fontWeight: "600",
            },
            "& p:nth-child(2)": {
              fontSize: "0.875rem",
              color: theme.palette.secondary.main,
              lineHeight: "1.063rem",
              fontWeight: "500",
            },
          },
        },
      },
      "& > div:nth-child(2)": {
        margin: 0,
        "@media(min-width:360px)": {
          margin: "50px 0 0",
        },
      },
    },
  }));
